import { useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Col, Grid, Row, theme } from 'antd';
import type { ContentDistributionPeriodDetailOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { DistributionPeriodElibriEventsTable } from '@/components/content_catalog/distribution_periods/DistributionPeriodElibriEventsTable';
import { DistributionPeriodUserCatalogCard } from '@/components/content_catalog/distribution_periods/DistributionPeriodUserCatalogCard';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import {
  DISTRIBUTION_PERIOD_DEFAULT_TAB,
  DISTRIBUTION_PERIOD_SHOW_TABS,
} from '../constants';
import { DistributionPeriodShowHeader } from './DistributionPeriodShowHeader';
import { DistributionPeriodGeneralTab } from './DistributionPeriodGeneralTab';

export const DistributionPeriodShow = () => {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const { query } = useShow<ContentDistributionPeriodDetailOut>({
    resource: 'content_catalog.distribution_periods',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle(
    'content_catalog.distribution_periods',
    record?.product_title
  );

  const [activeTab, onTabChange] = useShowTab(
    DISTRIBUTION_PERIOD_SHOW_TABS,
    DISTRIBUTION_PERIOD_DEFAULT_TAB
  );

  return (
    <Show
      isLoading={isLoading}
      canEdit={false}
      contentProps={bareShowContentProps}
    >
      {record && (
        <>
          <DistributionPeriodShowHeader
            record={record}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <Row
            gutter={[token.margin, token.margin]}
            style={{ marginTop: token.margin }}
          >
            <Col flex="1 1 480px" style={{ minWidth: 0 }}>
              {activeTab === 'general' && (
                <DistributionPeriodGeneralTab record={record} />
              )}
              {activeTab === 'elibri_events' && (
                <DistributionPeriodElibriEventsTable
                  events={record.elibri_events ?? []}
                />
              )}
            </Col>
            {activeTab === 'general' && (
              <Col flex={screens.lg ? '0 1 440px' : '0 1 300px'}>
                <DistributionPeriodUserCatalogCard record={record} />
              </Col>
            )}
          </Row>
        </>
      )}
    </Show>
  );
};
